
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[url]",
      function () {
        return require("private-next-pages/blog/[url].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/[url]"])
      });
    }
  